import { _GettersTree, defineStore } from 'pinia';

import { AbstractBaseStore, AbstractStoreState } from "@/stores/AbstractBase.store";
import { OrderDirection, OrderParameter } from '@/models/OrderParameter.model';
import { EvaluationLevel } from '@/models/EvaluationLevel.model';
import { EvaluationLevelFilterDef } from './filters/EvaluationLevelFilterDef';

interface EvaluationLevelsStoreState extends AbstractStoreState<EvaluationLevel, EvaluationLevelFilterDef> {

}

const BaseStore = AbstractBaseStore<EvaluationLevel, EvaluationLevelsStoreState, EvaluationLevelFilterDef>();

/**
 * Observation store.
 */
export const useEvaluationLevelsStore = defineStore('evaluationLevels', {


	/**
	 * Return the initial state of the store.
	 */
	state: (): EvaluationLevelsStoreState => {

		// Base state from the AbstractBaseStore
		return BaseStore.state({

			order: new OrderParameter('position', OrderDirection.ASC),
			defaultFilter: new EvaluationLevelFilterDef([]),

		});

	},

	getters: {

		...BaseStore.getters,

		apiPath(): string {
			return 'evaluation-levels';
		},

		defaultMask() {
			return [
				'*',
			];
		},

		defaultRecordsPerPage() {
			return 1000;
		},

		achievedLevels(state: EvaluationLevelsStoreState): EvaluationLevel[] {
			return state.items.filter((level) => level.position > 0)
				.sort((a, b) => {
					if (a.position === b.position) {
						return 0;
					}

					return a.position > b.position ? -1 : 1;
				}
			);
		},

		unachievedLevels(state: EvaluationLevelsStoreState): EvaluationLevel[] {
			return state.items.filter((level) => level.position <= 0).sort((a, b) => {
				if (a.position === b.position) {
					return 0;
				}

				return a.position > b.position ? -1 : 1;
			});
		}

	} as _GettersTree<EvaluationLevelsStoreState>,

	actions: {

		...BaseStore.actions,

		mapToItem(data: any): EvaluationLevel {
			return EvaluationLevel.createFromApiData(data);
		},

		new() {
			
		},

		async updateEvaluationLevels(levels: EvaluationLevel[]) {
			
			await this.loadOnce();

			const toRemove = this.items.filter((level) => {
				return !levels.find((l) => l.id === level.id);
			});

			// Store all levels
			await this.bulkSave(levels);

			// Remove all levels that are not in the new list
			for (const level of toRemove) {
				// not bulk.
				await this.delete(level);
			}

			// Sort on position
			this.afterLoad();

		},

		afterLoad() {
			// Sort on position
			this.items = this.items.sort((a, b) => {
				if (a.position === b.position) {
					return 0;
				}

				return a.position > b.position ? -1 : 1;
			});
		}
		
	}

});
